import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';

@Injectable()

export class HomeService {
    public addiApplicant: any;
    constructor(
        public db: AngularFirestore,
        public afAuth:AngularFireAuth
    ) { 
        this.addiApplicant = [];
    }

    deleteContact(request){
        return new Promise((resolve) => {
            let thiss = this;
            const usersData = this.db.collection('/users_data');
            const SDF_income = this.db.collection('/SDF_income');
            const SDF_liabilities = this.db.collection('/SDF_liabilities');
            if(request.document_id == "" || request.document_id == null || request.document_id == undefined){}else{
                let timestamp = new Date().getTime();
                if(request.contact_type == 'Primary Contact'){ 
                    thiss.getAllUsers(request.SDF_form_document_id).subscribe((data)=>{
                        if(data.length > 0){
                            data.forEach(uData => {
                                usersData.doc(uData.document_id).update({
                                    deleted: 1,
                                    deletedDate: timestamp
                                });
                            })
                        }
                        resolve('success');
                    })
                }else{
                    usersData.doc(request.document_id).update({
                        deleted: 1,
                        deletedDate: timestamp
                    }).then(function(doc) {
                        if(request.contact_uid == "" || request.contact_uid == null || request.contact_uid == undefined){}else{
                            thiss.getSecIncomes(request.SDF_form_document_id, request.contact_uid).subscribe((data)=>{
                                if(data.length > 0){
                                    data.forEach(uData => {
                                        SDF_income.doc(uData.document_id).update({
                                            deleted: 1,
                                            deletedDate: timestamp
                                        });
                                    })
                                }
                            })
                            thiss.getSecLiabilities(request.SDF_form_document_id, request.contact_uid).subscribe((data)=>{
                                if(data.length > 0){
                                    data.forEach(uData => {
                                        SDF_liabilities.doc(uData.document_id).update({
                                            deleted: 1,
                                            deletedDate: timestamp
                                        });
                                    })
                                }
                            })
                        }
                        resolve('success');
                    }).catch(err => {
                        console.log(err)
                    });
                }
            }
        });
    }

    restoreContact(request){
        return new Promise((resolve) => {
            let thiss = this;
            const usersData = this.db.collection('/users_data');
            const SDF_income = this.db.collection('/SDF_income');
            const SDF_liabilities = this.db.collection('/SDF_liabilities');
            if(request.document_id == "" || request.document_id == null || request.document_id == undefined){}else{
                if(request.contact_type == 'Primary Contact'){ 
                    thiss.getAllUsers(request.SDF_form_document_id).subscribe((data)=>{
                        if(data.length > 0){
                            data.forEach(uData => {
                                usersData.doc(uData.document_id).update({
                                    deleted: 0
                                });
                            })
                        }
                        resolve('success');
                    })
                }else{
                    usersData.doc(request.document_id).update({
                        deleted: 0
                    }).then(function(doc) {
                        if(request.contact_uid == "" || request.contact_uid == null || request.contact_uid == undefined){}else{
                            thiss.getSecIncomes(request.SDF_form_document_id, request.contact_uid).subscribe((data)=>{
                                if(data.length > 0){
                                    data.forEach(uData => {
                                        SDF_income.doc(uData.document_id).update({
                                            deleted: 0
                                        });
                                    })
                                }
                            })
                            thiss.getSecLiabilities(request.SDF_form_document_id, request.contact_uid).subscribe((data)=>{
                                if(data.length > 0){
                                    data.forEach(uData => {
                                        SDF_liabilities.doc(uData.document_id).update({
                                            deleted: 0
                                        });
                                    })
                                }
                            })
                        }
                        resolve('success');
                    }).catch(err => {
                        console.log(err)
                    });
                }
            }
        });
    }

    getAllUsers(SDF_form_document_id){
        return this.db.collection<any>( "users_data", ref => ref.where('SDF_form_document_id','==',SDF_form_document_id )).valueChanges ();
    }
    getSecIncomes(SDF_form_document_id, contact_uid){
        return this.db.collection<any>( "SDF_income", ref => ref.where('SDF_form','==',SDF_form_document_id ).where('uid','==',contact_uid )).valueChanges ();
    }
    getSecLiabilities(SDF_form_document_id, contact_uid){
        return this.db.collection<any>( "SDF_liabilities", ref => ref.where('SDF_form','==',SDF_form_document_id ).where('uid','==',contact_uid )).valueChanges ();
    }
}


// WEBPACK FOOTER //
// ./src/app/services/home-service.ts